/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrderResultModel from './OrderResultModel';

/**
* The OrderPlaceResultModel model module.
* @module model/OrderPlaceResultModel
* @version 1.0.0
*/
export default class OrderPlaceResultModel {
    /**
    * Constructs a new <code>OrderPlaceResultModel</code>.
    * @alias module:model/OrderPlaceResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>OrderPlaceResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/OrderPlaceResultModel} obj Optional instance to populate.
    * @return {module:model/OrderPlaceResultModel} The populated <code>OrderPlaceResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderPlaceResultModel();
                        
            
            if (data.hasOwnProperty('IdempotencyKey')) {
                obj['IdempotencyKey'] = ApiClient.convertToType(data['IdempotencyKey'], 'String');
            }
            if (data.hasOwnProperty('OrderId')) {
                obj['OrderId'] = ApiClient.convertToType(data['OrderId'], 'String');
            }
            if (data.hasOwnProperty('Order')) {
                obj['Order'] = OrderResultModel.constructFromObject(data['Order']);
            }
        }
        return obj;
    }

    /**
    * @member {String} IdempotencyKey
    */
    'IdempotencyKey' = undefined;
    /**
    * @member {String} OrderId
    */
    'OrderId' = undefined;
    /**
    * @member {module:model/OrderResultModel} Order
    */
    'Order' = undefined;




}
